import { render, staticRenderFns } from "./DepartmentSelect_1.vue?vue&type=template&id=67843fb8&scoped=true&"
import script from "./DepartmentSelect_1.vue?vue&type=script&lang=js&"
export * from "./DepartmentSelect_1.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentSelect_1.vue?vue&type=style&index=0&id=67843fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67843fb8",
  null
  
)

export default component.exports